// Registro do service worker (Fase 6.1 — cache offline; 5.3 — update toast).
//
// Só faz sentido no alvo web: Electron carrega via file:// (Service Worker
// API indisponível nesse esquema) e o app mobile via Capacitor já embute os
// assets localmente. Só registra em produção — em dev o SW cachearia builds
// antigos e atrapalharia o hot reload.
export function shouldRegisterServiceWorker({
  isProduction = import.meta.env.PROD,
  target = import.meta.env.VITE_TARGET,
  protocol = typeof window !== 'undefined' ? window.location.protocol : 'https:',
  hasServiceWorker = typeof navigator !== 'undefined' && 'serviceWorker' in navigator,
} = {}) {
  if (!isProduction) return false;
  if (!hasServiceWorker) return false;
  if (target && target !== 'web') return false;
  if (protocol === 'file:') return false;
  return true;
}

/** Tell waiting SW to activate, then reload when it takes control. */
export function activateWaitingServiceWorker(registration, {
  reload = () => window.location.reload(),
  addControllerChangeListener = (handler) => {
    navigator.serviceWorker.addEventListener('controllerchange', handler);
    return () => navigator.serviceWorker.removeEventListener('controllerchange', handler);
  },
} = {}) {
  const waiting = registration?.waiting;
  if (!waiting) return false;

  let reloaded = false;
  const onControllerChange = () => {
    if (reloaded) return;
    reloaded = true;
    reload();
  };
  addControllerChangeListener(onControllerChange);
  waiting.postMessage({ type: 'SKIP_WAITING' });
  return true;
}

function watchRegistration(registration, onWaiting) {
  if (!onWaiting) return;

  const notifyIfWaiting = () => {
    if (registration.waiting) onWaiting(registration);
  };

  notifyIfWaiting();

  registration.addEventListener('updatefound', () => {
    const installing = registration.installing;
    if (!installing) return;
    installing.addEventListener('statechange', () => {
      // New SW installed and an old controller exists → waiting for skipWaiting.
      if (installing.state === 'installed' && navigator.serviceWorker.controller) {
        notifyIfWaiting();
      }
    });
  });
}

let registrationStarted = false;

export function registerServiceWorker(options = {}) {
  if (!shouldRegisterServiceWorker(options)) return undefined;
  if (registrationStarted) return undefined;
  registrationStarted = true;

  const { onWaiting } = options;

  const start = () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        watchRegistration(registration, onWaiting);
        return registration;
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn('Falha ao registrar service worker:', err);
      });
  };

  if (typeof document !== 'undefined' && document.readyState === 'complete') {
    start();
  } else if (typeof window !== 'undefined') {
    window.addEventListener('load', start);
  }

  return undefined;
}

/** Test helper — allow re-register in jest. */
export function __resetServiceWorkerRegistrationForTests() {
  registrationStarted = false;
}
